import React from 'react'
import { render } from 'react-dom'
import WarrantyTemplate from './Warranty'
import WarrantyUpgradeTemplate from './WarrantyUpgrade'
import { user } from '../../core/controllers/user';

export default React.createClass({
    componentDidMount() {
        var self = this;
        this.state = {
            hasPermission: false
        }

        user.getPermissions(function(permissions) {
            const permission = permissions;
            if (permission != null && permission.length > 0 && permission.includes('warranty')) {
                self.setState({
                    hasPermission: true
                });
            }
        });
    },
    render(){
        const hasPermission = this.state != undefined ? this.state.hasPermission : false;
        return (
            <div class="row">
                { hasPermission ? (
                    <WarrantyTemplate />
                ) : (
                    <WarrantyUpgradeTemplate />
                )}
            </div>
        )
    }
});


// WEBPACK FOOTER //
// app/views/Warranty/index.js